import { render, staticRenderFns } from "./RouteLayout.vue?vue&type=template&id=3d9946a4&lang=pug"
import script from "./RouteLayout.vue?vue&type=script&lang=js"
export * from "./RouteLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports